<template>
    <div class="pay_res">
        <div v-if="loading" class="pay_res_loading">
            <van-loading type="spinner" size="48" />
            <p>{{ $t('payFail.loading') }}</p>
        </div>
        <template v-else>
            <template v-if="isSuccess">
                <div class="pay_res_a"><img src="../../assets/imgs/pay_suc.png" alt=""></div>
                <div class="pay_res_b">
                    <p>Congratulations on your successful payment, the product are: {{ orderInfoData.product_name }}</p>
                    <p>Product detail: </p>
                    <p class="weight">{{ orderInfoData.shop_content }}</p>
                </div>
                <div class="pay_res_c">
                    The goods you purchased have been sent to the in-game mailbox, please log in to the game to check!
                </div>
            </template>
            <template v-else>
                <div class="pay_res_a"><img src="../../assets/imgs/pay_fail.png" alt=""></div>
                <div class="pay_res_b">
                    <p>{{ $t('payFail.title') }}</p>
                </div>
                <div class="pay_res_c">
                    {{ $t('payFail.desc') }}
                </div>
            </template>
            <div class="pay_res_d" @click="backIndex">
              <div class="prod_role_btn">{{ $t('common.confirm') }}</div>
            </div>
            <cust></cust>
        </template>
    </div>
</template>

<script>
import { axiosServer } from '@/api/http';
import { Loading } from 'vant';
import { getSign } from "@/api/utils";
import cust from '../../components/customer.vue'
import { Dialog } from 'vant';
import eventReport, { EVENT_NAME } from '@/api/eventReport';
export default {
  data() {
    return {
      order_id: '',
      orderInfoData: {},
      game_id: '',
      area: '',
      server_id: '',
      role_id: '',
      app_key: '1df869f2e620513484ddbd5521313a60',
      loading: true,
      isSuccess: false,
    }
  },
  components: {
    cust,
    [Loading.name]: Loading,
  },
  created() {
    this.order_id = this.$route.query.order_id;
    this.game_id = this.$route.query.game_id;
    this.area = this.$route.query.area;
    this.server_id = this.$route.query.server_id;
    this.role_id = this.$route.query.role_id;
    this.getSuccOrderInfo('init');
  },
  methods: {
    getSuccOrderInfo(type) {
      this.loading = true;
      axiosServer({
        url: 'orderInfo',
        type: 'post',
        params: {
          order_id: this.order_id,
          sign: getSign(this.app_key, { order_id: this.order_id })
        }
      }).then(resa => {
        let res = resa.data;
        if (res && res.ret == 0) {
          this.isSuccess = true;
          this.orderInfoData = res.data;
        } else {
          Dialog.alert({ message: res && res.msg ? res.msg : this.$t('payFail.apiError') })
          this.isSuccess = false;
        }
        if (type == 'init') {
          eventReport.eventEnd(EVENT_NAME.LOAD_COMPLETE, {
            startEventName: EVENT_NAME.ENTER_OFFICIAL_RECHARGE,
            event_result: 1,
          });
        }
      }).catch(() => {
        this.isSuccess = false;
        Dialog.alert({ message: this.$t('payFail.apiError') })
        if (type == 'init') {
          eventReport.eventEnd(EVENT_NAME.LOAD_COMPLETE, {
            startEventName: EVENT_NAME.ENTER_OFFICIAL_RECHARGE,
            event_result: 2,
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    backIndex() {
      if (localStorage.getItem('pc_pay_page')) {
        this.$router.push({path: '/pcpay'});
      } else {
        this.$router.push({path: '/', query: {game_id: this.game_id, area: this.area, server_id: this.server_id, role_id: this.role_id, finish_pay: 1}});
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.pay_res{font-size: 0.28rem;}
.pay_res_loading{text-align: center;padding-top: 2rem;}
.pay_res_loading p{margin-top: 0.2rem;color: #999;}
.pay_res_a{text-align: center;}
.pay_res_a img{width: 4.6rem;}
.pay_res_d{padding: 0.2rem;}
.pay_res_b{text-align: center;padding: 0.2rem;}
.pay_res_b .weight{font-weight: bold;}
.pay_res_c{margin-top: 1rem;padding: 0 0.3rem;font-size: .28rem;color: #8b8b8b;}
.prod_role_btn{
    width: 100%;
    height: .73rem;
    background: #4378ff;
    color: #fff;
    text-align: center;
    line-height: 0.73rem;
    font-size: .28rem;
  }
</style>
